import { Injectable, signal } from '@angular/core';
import { InventoryTabKeys } from '@app/utils/enums/inventory-table-columns.enum';

@Injectable({
  providedIn: 'root',
})
export class EditInventoryUiService {
  public readonly isHeaderCollapsed = signal(false);
  public readonly activeTab = signal<InventoryTabKeys>(InventoryTabKeys.general);

  public setHeaderCollapsed(collapsed: boolean): void {
    this.isHeaderCollapsed.set(collapsed);
  }

  public setActiveTab(tab: InventoryTabKeys): void {
    this.activeTab.set(tab);
  }
}
